// extracted by mini-css-extract-plugin
export default {"definingsection":"definingsection_a80a0e394d07d700337f","codeview":"codeview_a3f3f4b108bc2c5203a6"};